import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("下载文件")
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.pictureModal.pictureModalFlag,
    title: _ctx.pictureModal.pictureModalTitle,
    width: _ctx.width,
    onCancel: _ctx.close,
    footer: _ctx.footer,
    centered: _ctx.centered,
    wrapClassName: _ctx.wrapClassName
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.downloadFile
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      (!_ctx.isPdf)
        ? (_openBlock(), _createBlock(_component_a_image, {
            key: 0,
            src: _ctx.pictureModal.pictureModalImg
          }, null, 8, ["src"]))
        : (_openBlock(), _createElementBlock("iframe", {
            key: 1,
            src: _ctx.pictureModal.pdf,
            frameborder: "0",
            width: "100%",
            height: "500px"
          }, null, 8, _hoisted_2))
    ]),
    _: 1
  }, 8, ["visible", "title", "width", "onCancel", "footer", "centered", "wrapClassName"]))
}